import request from '../../utils/request.js'
import axios from 'axios'
import { uploadBaseUrl } from '../../utils/base.js'
import Cookies from 'js-cookie'
const uploadService = axios.create({
    baseURL: uploadBaseUrl,
    timeout: 300000,
    withCredentials: false,
    crossDomain: true
})
// 添加请求拦截器
uploadService.interceptors.request.use(
    config => {
        const token = Cookies.get('token')
        if (token) {
            config.headers.Authorization = token
        }
        if (!(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/json'
        } else if (config.headers['Content-Type']) {
            delete config.headers['Content-Type']
        }
        console.log('文件上传请求配置:', {
            url: config.url,
            method: config.method,
            hasToken: !!token,
            isFormData: config.data instanceof FormData,
            headers: config.headers
        })
        return config
    },
    error => {
        console.error('文件上传请求错误:', error)
        return Promise.reject(error)
    }
)

// 添加响应拦截器
uploadService.interceptors.response.use(
    response => {
        console.log('文件上传响应接收:', response)
        const { data } = response
        // 根据业务状态码处理
        if (data.code === 200 || data.code === 0) {
            return data
        } else if (data.code === 401) {
            // token 过期，清除本地存储
            Cookies.remove('token')
            return Promise.reject(new Error(data.message || '登录已过期'))
        } else if (data.code === 4005) {
            // 未登录
            return Promise.reject(new Error(data.message || '请先登录'))
        } else {
            return Promise.reject(new Error(data.message || '请求失败'))
        }
    },
    error => {
        console.error('文件上传响应错误:', error)
        console.error('错误详情:', {
            message: error.message,
            code: error.code,
            response: error.response,
            request: error.request,
            config: error.config
        })
        let message = '网络错误'
        if (error.response) {
            const { status, data } = error.response
            console.log('服务器响应状态:', status, '响应数据:', data)
            switch (status) {
                case 400:
                    message = data.message || '请求参数错误'
                    break
                case 401:
                    message = '未授权，请重新登录'
                    break
                case 403:
                    message = '拒绝访问'
                    break
                case 404:
                    message = '请求地址不存在'
                    break
                case 500:
                    message = '服务器内部错误'
                    break
                default:
                    message = data.message || `连接错误${status}`
            }
        } else if (error.code === 'ECONNABORTED') {
            message = '请求超时'
        } else if (error.message === 'Network Error') {
            message = '网络连接异常'
        } else if (error.message.includes('CORS') || error.message.includes('cors')) {
            message = '跨域请求被阻止，请检查服务器CORS配置'
        } else if (error.code === 'ERR_NETWORK') {
            message = '网络连接失败，请检查网络连接'
        } else if (error.code === 'ERR_CANCELED') {
            message = '请求被取消'
        }
        return Promise.reject(new Error(message))
    }
)
// 分片初始化接口
export const initChunk = (data) => {
    return uploadService.post('/x-file/upload/multipart/init', data)
}
// 合并分片文件，完成上传
export const complete = (data) => {
    return uploadService.post('/x-file/upload/multipart/complete', data)
}
//单个文件上传
export const uploadFile = (data) => {
    return uploadService.post('/x-file/upload/file', data)
}